import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { subscriptionShape } from '@bibliocommons/bc-prop-types';

import Heading from 'app/components/shared/Heading';
import Divider from 'app/components/bibs/shared/Divider';

import SubscriptionNotes from './SubscriptionNotes';

import './Subscriptions.scss';

function transformValue(field, item) {
  switch (field) {
    case 'notes': {
      const notesToDisplay = item.get(field).filter(type => !!type.size);
      return notesToDisplay.size > 0 && <SubscriptionNotes notes={notesToDisplay} />;
    }

    case 'collection': {
      const collection = item.get(field);
      return collection && <span className="collection">{collection}</span>;
    }

    case 'runDuration': {
      const durationNotes = item.get(field);
      return (
        durationNotes.size > 0 &&
        durationNotes
          .get(0)
          .filter(text => !!text)
          .map((content, type) => {
            let result = '';
            if (type === 'beginText') result += content;
            if (type === 'endText') result += ` - ${content}`;
            if (type === 'note') result += ` (${content})`;
            return result;
          })
          .toList()
      );
    }

    default:
      return item.get(field);
  }
}

function getFieldItems(subscription) {
  const fieldsToDisplay = ['collection', 'callNumbers', 'notes', 'mediaType', 'runDuration', 'status'];
  return Immutable.Map(fieldsToDisplay.map(field => [field, transformValue(field, subscription)])).filter(
    (value, label) => fieldsToDisplay.includes(label) && !!value
  );
}

function renderFields(subscription) {
  const subscriptionEntries = getFieldItems(subscription);
  return subscriptionEntries
    .map((value, label) => {
      const fieldLabel = label === 'callNumbers' ? 'callNumber' : label;
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div className="subscription-field" key={label}>
          <div className="field-label">
            <FormattedMessage id={fieldLabel} />
          </div>
          <div className="field-values">{value}</div>
        </div>
      );
    })
    .toList();
}

function renderGroup(group) {
  return (
    <div className="subscription-group">
      <Heading tagName="h4" size="modest" className="subscription-heading">
        {group.first().get('location')}
      </Heading>
      {group
        .map(subscription => (
          <div className="subscription-content" key={subscription.get('id')}>
            {renderFields(subscription)}
            <br />
          </div>
        ))
        .toList()}
    </div>
  );
}

export default function Subscriptions({ subscriptions }) {
  if (subscriptions.size === 0) return null;

  const groups = subscriptions.groupBy(subscription => subscription.get('location'));

  return (
    <div className="cp-subscriptions">
      {groups
        .map((group, location) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="group" key={location.toLowerCase()}>
            {renderGroup(group)}
            <Divider />
          </div>
        ))
        .toList()}
    </div>
  );
}

Subscriptions.propTypes = {
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape)
};
